import {
  ResponsiveContainer,
  Bar,
  BarChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  LabelList,
} from "recharts";

export default function ScholarshipRequestDistrictChart({ data }) {
  const sortedData = [...data].sort((a, b) => b.total - a.total);

  return (
    <div style={{ display: "flex", gap: "30px" }}>
      <ResponsiveContainer
        width="100%"
        height={1300}
        style={{ display: "flex", justifyContent: "flex-start" }}
      >
        <BarChart
          data={sortedData}
          layout="vertical"
          margin={{ top: 10, right: 10, left: -30, bottom: 10 }}
        >
          <CartesianGrid strokeDasharray="3 3" horizontal={false} />
          <XAxis type="number" />
          <YAxis
            type="category"
            dataKey="district"
            width={150}
            orientation="left"
            tick={{ textAnchor: "start", dx: -95 }}
          />
          <Tooltip
            formatter={(value, label) => [
              `${value?.toLocaleString()} ${
                value == 1 ? "Request" : "Requests"
              }`,
              label,
            ]}
          />
          <Legend />
          <Bar
            dataKey="total"
            fill="hsl(var(--chart-1))"
            name="Requests"
            barSize={20}
          >
            <LabelList
              dataKey="total"
              position="right"
              formatter={(value) => value.toLocaleString()}
              style={{
                fontWeight: "bold",
                fontSize: 16,
                fill: "black",
              }}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
      <table
        style={{ borderCollapse: "collapse", width: "100%", width: "70%" }}
      >
        <thead>
          <tr style={{ backgroundColor: "#f9f9f9" }}>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px 10px 10px 20px",
                textAlign: "left",
              }}
            >
              District
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Male
            </th>
            <th
              style={{
                border: "1px solid #ddd",
                padding: "10px",
                textAlign: "center",
              }}
            >
              Female
            </th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr
              key={index}
              style={{
                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#fff",
              }}
            >
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px 10px 10px 20px",
                }}
              >
                {item.district}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.male?.toLocaleString()}
              </td>
              <td
                style={{
                  border: "1px solid #ddd",
                  padding: "10px",
                  textAlign: "center",
                }}
              >
                {item.female?.toLocaleString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
